<template>
  <div class="navigation-bar">
    <template v-if="mode === 'problem'">
      <v-btn
        variant="text"
        @click="scrollToSection('2-Problem Need')"
        :class="{ selected: selectedSection === '2-Problem Need' }"
      >
        <span class="small-text font-weight-bold">Problem</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('1-Decision Purpose')"
        :class="{ selected: selectedSection === '1-Decision Purpose' }"
      >
        <span class="small-text font-weight-bold">Location</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('3-Design Space')"
        :class="{ selected: selectedSection === '3-Design Space' }"
      >
        <span class="small-text font-weight-bold">Building Considered</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('4-Simulation Requirements')"
        :class="{ selected: selectedSection === '4-Simulation Requirements' }"
      >
        <span class="small-text font-weight-bold">Stakeholders</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('5-Modeling Choice')"
        :class="{ selected: selectedSection === '5-Modeling Choice' }"
      >
        <span class="small-text font-weight-bold">KPIs</span>
      </v-btn>
    </template>

    <template v-else>
      <v-btn
        variant="text"
        @click="scrollToSection('solution-scenarios')"
        :class="{ selected: selectedSection === 'solution-scenarios' }"
      >
        <span class="small-text font-weight-bold">Scenarios</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('solution-requirements')"
        :class="{ selected: selectedSection === 'solution-requirements' }"
      >
        <span class="small-text font-weight-bold">Requirements</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('solution-model-risk')"
        :class="{ selected: selectedSection === 'solution-model-risk' }"
      >
        <span class="small-text font-weight-bold">Accepted Model Risk</span>
      </v-btn>
      <v-btn
        variant="text"
        @click="scrollToSection('solution-simulation-tools')"
        :class="{ selected: selectedSection === 'solution-simulation-tools' }"
      >
        <span class="small-text font-weight-bold">Simulation Tools</span>
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  name: "NavigationBar",
  props: {
    mode: {
      type: String,
      default: "problem",
      validator: (value) => ["problem", "solution"].includes(value),
    },
  },
  data() {
    return {
      selectedSection: "",
    };
  },
  computed: {
    sections() {
      if (this.mode === "problem") {
        return [
          "2-Problem Need",
          "1-Decision Purpose",
          "3-Design Space",
          "4-Simulation Requirements",
          "5-Modeling Choice",
        ];
      } else {
        return [
          "solution-scenarios",
          "solution-requirements",
          "solution-model-risk",
          "solution-simulation-tools",
        ];
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    scrollToSection(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        this.selectedSection = sectionId;
      }
    },
    onScroll() {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        let currentSection = "";

        this.sections.forEach((sectionId) => {
          const section = document.getElementById(sectionId);
          if (section) {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 50 && rect.bottom >= 50) {
              currentSection = sectionId;
            }
          }
        });

        if (currentSection) {
          this.selectedSection = currentSection;
        }
      }, 100);
    },
  },
};
</script>

<style scoped>
.navigation-bar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.small-text {
  font-size: 12px;
}

.font-weight-bold {
  font-weight: bold;
}

.selected {
  background-color: var(--primaryColor) !important;
  color: var(--backgroundColor) !important;
}
</style>
